import { FC, Fragment, useEffect, useState, useMemo } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { t } from "i18next";

import { selectUser, setAccessToken } from "@/app/auth/auth.slice";
import { ProfileListModal } from "../organisms/ProfileListModal";
import { useOtherProfilesQuery } from "@/app/auth/auth.api";
import Navbar from "../organisms/Navbar";
import { Permission } from "@/shared/hooks/usePermission";
import { ROLE_NAMES } from "../organisms/BranchSideBar";

const navigation = [
  {
    name: "KPIs",
    href: "/kpis",
    permission: Permission.ACCESS_KPI,
    roles: [
      ROLE_NAMES.SUPER_ADMIN,
      ROLE_NAMES.COMMERCIAL,
      ROLE_NAMES.ADMIN,
      ROLE_NAMES.COACH,
      ROLE_NAMES.TRAINER_PERSONAL,
      ROLE_NAMES.RECEPTIONIST,
    ],
  },
  {
    name: t("gym.views.gyms"),
    href: "/gyms",
    permission: Permission.BRANCH_ACCESS_MANAGE_COMPANY_AGREEMENTS,
    roles: [ROLE_NAMES.SUPER_ADMIN, ROLE_NAMES.MANAGER],
  },
  {
    name: t("branch.views.branchs"),
    href: "/branchs",
    permission: Permission.BRANCH_ACCESS_ALL_BRANCHES,
    roles: [
      ROLE_NAMES.SUPER_ADMIN,
      ROLE_NAMES.MANAGER,
      ROLE_NAMES.COMMERCIAL,
      ROLE_NAMES.ADMIN,
    ],
  },
  {
    name: t("user.views.users"),
    href: "/users",
    permission: Permission.USERS_ACCESS,
    roles: [
      ROLE_NAMES.SUPER_ADMIN,
      ROLE_NAMES.MANAGER,
      ROLE_NAMES.COMMERCIAL,
      ROLE_NAMES.ADMIN,
      ROLE_NAMES.COACH,
      ROLE_NAMES.TRAINER_PERSONAL,
      ROLE_NAMES.RECEPTIONIST,
    ],
  },
  {
    name: t("ticket.views.loyalty_assistant_2"),
    href: "/assigned",
    permission: Permission.LOYALTY_VIEW_COMPLETED_TASKS,
    roles: [
      ROLE_NAMES.SUPER_ADMIN,
      ROLE_NAMES.COMMERCIAL,
      ROLE_NAMES.ADMIN,
      ROLE_NAMES.COACH,
      ROLE_NAMES.TRAINER_PERSONAL,
      ROLE_NAMES.RECEPTIONIST,
    ],
  },
  {
    name: "Accesos",
    href: "/access",
    permission: Permission.ACCESS_KPI,
    roles: [
      ROLE_NAMES.SUPER_ADMIN,
      ROLE_NAMES.COMMERCIAL,
      ROLE_NAMES.ADMIN,
      ROLE_NAMES.COACH,
      ROLE_NAMES.TRAINER_PERSONAL,
      ROLE_NAMES.RECEPTIONIST,
    ],
  },
];

export const ViewStandardLayout: FC<any> = () => {
  const dispatch = useDispatch();
  const otherProfilesQuery = useOtherProfilesQuery(undefined);
  const [profileListVisible, setProfileListVisible] = useState(false);
  const location = useLocation();

  const user = useSelector(selectUser);

  const updatedNavigation = useMemo(() => {
    if (!user || !user.role) {
      return [];
    }

    return navigation
      .filter((item) => item.roles.includes(user.role))
      .map((item) => ({
        ...item,
        current: item.href === location.pathname,
      }));
  }, [user, location.pathname]);

  return (
    <Fragment>
      <div className="flex flex-col h-screen overflow-hidden">
        <Navbar
          navigation={updatedNavigation}
          user={user}
          onChangeProfile={() => setProfileListVisible(true)}
        />
        <div className="flex flex-1 overflow-hidden">
          <div className="flex-1 overflow-auto">
            <div className="mt-1">
              <Outlet />
            </div>
          </div>
        </div>
      </div>

      <ProfileListModal
        visible={profileListVisible}
        setVisible={setProfileListVisible}
        profiles={otherProfilesQuery.data ?? []}
        onSelectProfile={(profile) => {
          localStorage.setItem("accessToken", profile.accessToken);
          dispatch(setAccessToken({ accessToken: profile.accessToken }));
          setProfileListVisible(false);
        }}
      />
    </Fragment>
  );
};
